<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="isHtml"
    class="element-description"
    v-html="provideSanitized(text)"
  />
  <p v-else v-text="text" />
</template>

<script setup lang="ts">
  interface IProps {
    text?: string;
    isHtml?: boolean;
  }

  withDefaults(defineProps<IProps>(), {
    text: '',
    isHtml: false,
  });
</script>

<style lang="scss" scoped>
  .element-description:deep(a) {
    @apply font-bold text-blue-400 underline;
  }

  .element-description:deep(ul) {
    padding-left: 1.75rem; // 28px
    list-style-type: disc;
  }

  .element-description:deep(ol) {
    padding-left: 1.5rem;
    list-style-type: decimal;
  }
</style>
